import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { Property } from '../../domain/property';
import {
   PhobosTaskInstance,
   PhobosTaskInstancePmsDataItem
} from '../../domain/phobos-task-instance';
import { WorkflowFile } from '../../domain/workflow-file';
import { Task } from '../../domain/task';
import { Group } from '../../domain/group';
import { PhobosTaskInstanceService } from '../../services/phobos-task-instance.service';
import { PropertyStoreService } from '../../services/stores/property-store.service';
import { ActivatedRoute, Router } from '@angular/router';
import { WorkflowType } from '../../domain/enums/workflow-type';
import { ITaskComponent } from '../interfaces/i-task-component';
import { TaskParent } from '../parents/task-parent';
import { MentionStoreService } from '../../services/stores/mention-store.service';
import { FollowUpStoreService } from '../../services/stores/follow-up-store.service';
import { DocumentSidePanelComponent } from '../../panel-components/document-side-panel/document-side-panel.component';
import { RefreshDataState } from '../../domain/refresh-data-state';
import { DataStoreService } from '../../services/data-store.service';
import { UploadFile } from '../../domain/uploadfile';
import { MessageService } from 'primeng/api';
import { TaskService } from '../../services/task.service';
import { DropDownStoreService } from '../../services/stores/drop-down-store.service';
import { ModelSummary } from '../../domain/Ai/model-summary';
import { HttpClient } from '@angular/common/http';
import { getReportTypeByPmsReportTypeId } from '../html-report-viewer/report-definitions/pms-report-type-registry';
import { take } from 'rxjs/operators';

import {
   ReportViewerAvailability,
   ReportViewerKind
} from '../../domain/reporting/report-viewer.models';

const REPORT_PANEL_EXPANDED_STORAGE_KEY = 'tyalls.task-details.report-expanded';

@Component({
   selector: 'app-tasks-detail-phobos',
   templateUrl: './tasks-detail-phobos.component.html',
   styleUrl: './tasks-detail-phobos.component.scss'
})
export class TasksDetailPhobosComponent
   extends TaskParent
   implements OnInit, ITaskComponent
{
   @ViewChild(DocumentSidePanelComponent) documentSidePanelComponent:
      | DocumentSidePanelComponent
      | undefined;
   currentProperty: Property | undefined;
   phobosTaskInstance: PhobosTaskInstance;
   mainPdfContainer: string;
   primaryFile: WorkflowFile;
   isLoading: boolean;
   hasError: boolean;
   selectedGroup: Group | undefined;
   isCompleteFormVisible: boolean;
   isCommentDialogVisible: boolean;
   isResend: boolean;
   formId: number;
   pdfCss: string;
   commentsCss: string;
   pdfPanelInFocus: boolean;
   reportPanelExpanded: boolean;
   flexCss: string;
   type: number;
   isSubmitting: boolean = false;
   aiData?: ModelSummary;
   protected readonly WorkflowType = WorkflowType;

   public htmlReportData: any = null;
   public showHtmlReport = false;
   public mentionTargetRowId: string | null = null;
   private mentionTargetPmsDataId: number | null = null;
   public reportType: string | null = null;
   public htmlSeedAnnotations: any = null;
   public isHtmlReportLoading = true;
   public isHtmlReportEnabled = true;
   public useApiHtmlAnnotations = true;

   public activeReportViewer: ReportViewerKind = 'pdf';

   get reportViewerAvailability(): ReportViewerAvailability {
      return {
         hasPdfReport: this.primaryFile?.storageId !== undefined,
         hasHtmlReport:
            this.showHtmlReport && !!this.htmlReportData && !this.isHtmlReportLoading
      };
   }

   constructor(
      private formTaskService: PhobosTaskInstanceService,
      private mentionStore: MentionStoreService,
      private followupStore: FollowUpStoreService,
      private messageService: MessageService,
      private taskService: TaskService,
      private _propertyStore: PropertyStoreService,
      private _route: ActivatedRoute,
      private router: Router,
      private cdr: ChangeDetectorRef,
      private dataStoreService: DataStoreService,
      private propStore: PropertyStoreService,
      private dropDownStore: DropDownStoreService,
      private http: HttpClient
   ) {
      super(router, propStore);
      this.mainPdfContainer = 'form-pdf-container';
      this.isLoading = true;
      this.hasError = false;
      this.isCompleteFormVisible = false;
      this.isCommentDialogVisible = false;
      this.primaryFile = new WorkflowFile();
      this.phobosTaskInstance = new PhobosTaskInstance();
      this.formId = 0;
      this.isResend = false;
      this.pdfCss = 'xl:col-8 col-12';
      this.commentsCss = 'xl:col-3 col-12';
      this.pdfPanelInFocus = true;
      this.reportPanelExpanded = false;
      this.flexCss = 'flex justify-content-end gap-3';
      this.type = 0;
      if (this.getStoredReportPanelExpanded()) {
         this.toggleReportPanel(false);
      }
      this._propertyStore.currentProperty.subscribe((property) => {
         this.currentProperty = property;
      });
   }

   ngOnInit(): void {
      this.updateDropDownState(true);
      this._route.params.subscribe((params: any) => {
         this.hasError = false;
         this.isLoading = true;

         this.loadMentionNavigationTarget();

         if (params.id) {
            this._propertyStore.setIsPropertyChangeEnabled(false);
            this.hasError = false;
            this.isLoading = true;
            this.resetHtmlViewerState();
            this.formId = params.id;
            this.getAiData();
            this._propertyStore.currentProperty
               .pipe(take(1))
               .subscribe((property) => {
                  this.currentProperty = property;
                  this.getTaskFile();
               });
         }
      });
   }

   // Method to update boolean inside DropDownStoreService
   updateDropDownState(value: boolean): void {
      this.dropDownStore.setDropDownState(value);
   }

   getTaskFile(): void {
      if (this.formId !== 0) {
         this.formTaskService.getPhobosTaskInstance(this.formId).subscribe(
            (fti) => {
               this.updateTaskInstance(fti);
            },
            () => {
               this.currentTask = new Task();
               this.primaryFile = new WorkflowFile();
               this.primaryFile.storageId = undefined;
               this.primaryFile.documentId = undefined;
               this.primaryFile.isPrimary = true;
               this.primaryFile.createdDate = undefined;
               this.primaryFile.type = undefined;
               this.isLoading = false;
               this.hasError = true;
            }
         );
      }
   }

   getAiData(): void {
      if (this.formId !== 0) {
         this.formTaskService.getPhobosTaskInstanceAiData(this.formId).subscribe({
            next: (aiData) => {
               this.aiData = aiData;
            },
            error: () => {
               this.aiData = undefined;
            }
         });
      }
   }

   get primaryPmsDataStatus(): string | null {
      return this.primaryPmsData?.status ?? null;
   }

   get primaryPmsDataId(): number | null {
      return this.primaryPmsData?.id ?? null;
   }

   private get primaryPmsData(): PhobosTaskInstancePmsDataItem | null {
      const pmsData = this.phobosTaskInstance?.pmsData ?? [];

      if (!pmsData.length) {
         return null;
      }

      if (this.mentionTargetPmsDataId) {
         const targetPmsData = pmsData.find(
            (item) => item.id === this.mentionTargetPmsDataId
         );

         if (targetPmsData) {
            return targetPmsData;
         }
      }

      return pmsData[0];
   }

   updateTaskInstance(fti: PhobosTaskInstance) {
      if (fti.propertyId !== this.currentProperty?.id) {
         this.hasError = true;
         this.isLoading = false;
      } else {
         this.currentTask = new Task();
         this.currentTask.name = fti.name;
         this.currentTask.dueDate = fti.createdDate;
         this.currentTask.processId = this.formId;
         this.currentTask.type = fti.type;
         this.currentTask.description = fti.description;
         this.currentTask.isAssignedToUser = fti.isAssignedToUser;
         this.primaryFile = new WorkflowFile();
         this.primaryFile.storageId =
            fti.documentId === null ? undefined : fti.documentId;
         this.primaryFile.documentId = fti.id;
         this.primaryFile.type = fti.type;
         this.primaryFile.isPrimary = true;
         this.primaryFile.createdDate = new Date(fti.createdDate);
         this.isLoading = false;
         this.phobosTaskInstance = fti;
         this.configureReportViewerFromApi(fti);
         if (history.state?.task) {
            this.currentTask.nextTask = history.state?.task.nextTask;
            this.currentTask.prevTask = history.state?.task.prevTask;
         }
         this.cdr.detectChanges();
      }
   }

   assign($event: MouseEvent) {
      $event.preventDefault();
      if (this.phobosTaskInstance && this.selectedGroup && this.currentProperty) {
         this.isLoading = true;
         this.isSubmitting = true;
         this.formTaskService
            .assignPhobosTaskInstance(
               this.phobosTaskInstance?.id,
               this.selectedGroup?.id,
               this.currentProperty?.id
            )
            .subscribe({
               next: () => {
                  const refreshDate = new RefreshDataState();
                  refreshDate.ClaimedTasks = true;
                  refreshDate.UnclaimedTasks = true;
                  refreshDate.MyTasks = true;
                  refreshDate.MyTasksMonthly = true;
                  this.dataStoreService.refreshTaskData(refreshDate);
                  this.childRouter.navigate(['/dashboard']);
               },
               complete: () => {
                  this.isSubmitting = false;
               }
            });
      }
   }

   groupSelected($event: any) {
      this.selectedGroup = $event;
   }

   complete($event: MouseEvent) {
      $event.preventDefault();
      if (this.phobosTaskInstance) {
         this.isCompleteFormVisible = true;
      }
   }

   reOpen($event: MouseEvent) {
      $event.preventDefault();
      this.isSubmitting = true;
      this.formTaskService.reOpenPhobosTaskInstance(this.formId).subscribe({
         next: () => {
            this.messageService.add({
               severity: 'success',
               summary: 'Task Re-opened',
               detail: `Task ${this.formId} has been re-opened`
            });
            this.refreshData();
            this.getTaskFile();
         },
         error: (err) => {
            this.messageService.add({
               severity: 'error',
               summary: 'Re-open Failed',
               detail: `Failed to re-open task ${this.formId}: ${err.message || 'Unexpected error.'}`
            });
         },
         complete: () => {
            this.isSubmitting = false;
         }
      });
   }

   completeFormDialogClose(): void {
      this.isCompleteFormVisible = false;
      this.currentTask.isAssignedToUser = false;
      this.isResend = false;
      this.getTaskFile();
   }

   // eslint-disable-next-line @typescript-eslint/no-unused-vars
   changeCurrentTask(newTask: Task): void {}

   onDialogClose(): void {
      this.isCommentDialogVisible = false;
      this.refreshData();
   }

   refreshData(): void {
      this.followupStore.refreshStore();
      this.mentionStore.refreshStore();
      if (this.documentSidePanelComponent) {
         this.documentSidePanelComponent.getComments();
      }
   }

   openCommentDialog(): void {
      this.isCommentDialogVisible = true;
   }

   resend($event: MouseEvent) {
      $event.preventDefault();
      if (this.phobosTaskInstance) {
         this.isResend = true;
         this.isCompleteFormVisible = true;
      }
   }

   uploadWorkflowFile($event: { file: UploadFile[] }) {
      const currentFile = $event.file.pop();
      if (currentFile && this.formId) {
         this.formTaskService
            .uploadWorkflowFile(this.formId, currentFile.file)
            .subscribe((file) => {
               this.updateTaskInstance(file);
            });
      }
   }

   onReview() {
      if (this.phobosTaskInstance.id) {
         this.isSubmitting = true;
         this.taskService.completeTask(this.phobosTaskInstance.id).subscribe({
            next: () => {
               this.currentTask.isComplete = true;
               // Refresh Send Back visibility after review (it hides if the task now has completedDate)
               this.documentSidePanelComponent?.refreshSendBackAvailability();
               this.messageService.add({
                  severity: 'success',
                  summary: 'Task has been reviewed',
                  detail: `${this.phobosTaskInstance.id} tasks reviewed`
               });
               const refreshDate = new RefreshDataState();
               refreshDate.ClaimedTasks = true;
               refreshDate.UnclaimedTasks = true;
               refreshDate.MyTasks = true;
               refreshDate.MyTasksMonthly = true;
               this.dataStoreService.refreshTaskData(refreshDate);
            },
            complete: () => {
               this.isSubmitting = false;
            }
         });
      }
   }

   // General task-level content is already loaded by the document side panel.
   // Do not include per-row report comments or supporting documents here.
   get generalTaskCommentCount(): number {
      return this.documentSidePanelComponent?.comments?.length ?? 0;
   }

   get generalTaskFileCount(): number {
      return this.documentSidePanelComponent?.supportingFiles?.length ?? 0;
   }

   openGeneralTaskComments(): void {
      this.getOpenComment();
      this.documentSidePanelComponent?.showCommentsView();
   }

   openGeneralTaskFiles(): void {
      this.getOpenComment();
      this.documentSidePanelComponent?.showSupportingFilesView();
   }

   getOpenComment() {
      this.pdfCss = 'xl:col-3 col-12';
      this.commentsCss = 'xl:col-8 col-12';
      this.pdfPanelInFocus = false;
      this.reportPanelExpanded = false;
      this.flexCss = '';
   }

   getOpenPdf() {
      this.pdfCss = 'xl:col-8 col-12';
      this.commentsCss = 'xl:col-3 col-12';
      this.pdfPanelInFocus = true;
      this.reportPanelExpanded = false;
      this.flexCss = 'flex justify-content-end gap-3';
   }

   toggleReportPanel(persistPreference = true): void {
      if (this.reportPanelExpanded) {
         this.getOpenPdf();
      } else {
         this.pdfCss = 'xl:col-11 col-12';
         this.commentsCss = 'hidden';
         this.pdfPanelInFocus = true;
         this.reportPanelExpanded = true;
         this.flexCss = 'flex justify-content-end gap-3';
      }

      if (persistPreference) {
         this.persistReportPanelExpanded();
      }
   }

   private getStoredReportPanelExpanded(): boolean {
      try {
         return (
            window.localStorage.getItem(REPORT_PANEL_EXPANDED_STORAGE_KEY) === 'true'
         );
      } catch (error) {
         console.warn('Unable to load task report layout preference', error);
         return false;
      }
   }

   private persistReportPanelExpanded(): void {
      try {
         window.localStorage.setItem(
            REPORT_PANEL_EXPANDED_STORAGE_KEY,
            String(this.reportPanelExpanded)
         );
      } catch (error) {
         console.warn('Unable to save task report layout preference', error);
      }
   }

   refreshTaskInstance(): void {
      this.isLoading = true;
      this.getTaskFile();
   }

   private loadMentionNavigationTarget(): void {
      const targetRowId =
         this._route.snapshot.queryParamMap.get('rowId')?.trim() ?? '';

      const rawPmsDataId = this._route.snapshot.queryParamMap.get('pmsDataId');
      const parsedPmsDataId = rawPmsDataId ? Number(rawPmsDataId) : null;

      this.mentionTargetRowId = targetRowId || null;

      this.mentionTargetPmsDataId =
         parsedPmsDataId !== null &&
         Number.isInteger(parsedPmsDataId) &&
         parsedPmsDataId > 0
            ? parsedPmsDataId
            : null;
   }

   private resetHtmlViewerState(): void {
      this.showHtmlReport = false;
      this.reportType = null;
      this.htmlReportData = null;
      this.isHtmlReportLoading = false;
      this.activeReportViewer = 'pdf';
   }

   private configureReportViewerFromApi(taskInstance: PhobosTaskInstance): void {
      this.resetHtmlViewerState();

      if (!this.isHtmlReportEnabled) return;

      const rawReportData = this.primaryPmsData?.data;
      if (!rawReportData) return;

      this.isHtmlReportLoading = true;

      try {
         this.htmlReportData =
            typeof rawReportData === 'string'
               ? JSON.parse(rawReportData)
               : rawReportData;

         this.reportType = this.getHtmlReportType(taskInstance);

         if (!this.reportType) {
            this.resetHtmlViewerState();
            return;
         }

         this.showHtmlReport = true;
         this.activeReportViewer = 'html';
      } catch (error) {
         console.error('Failed to parse PMS report data JSON', error);

         // Fall back safely to PDF
         this.resetHtmlViewerState();
         this.activeReportViewer = 'pdf';
      } finally {
         this.isHtmlReportLoading = false;
      }
   }

   private getHtmlReportType(fti: PhobosTaskInstance): string | null {
      const reportType = getReportTypeByPmsReportTypeId(fti?.pmsReportTypeId);

      if (!reportType) {
         console.warn('No HTML report definition mapping found for PMS report type', {
            pmsReportTypeId: fti?.pmsReportTypeId,
            pmsReportTypeName: fti?.pmsReportTypeName
         });
      }

      return reportType;
   }
}
